export default "__VITE_ASSET__C49p3hTB__"